import React, { useState } from 'react';
import { 
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import NavbarBrand from './NavbarBrand';
import menuData from '../data/menuData.json';
import '../styles/navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <AppBar className="navbar-mui" position="fixed">
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <NavbarBrand />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box className="desktop-menu">
            {menuData.map((item) => (
              <Box key={item.id} className="menu-item">
                <a href={item.link}>{item.title}</a>
              </Box>
            ))}
          </Box>
          <IconButton
            className="menu-toggle"
            color="inherit"
            edge="end"
            onClick={toggleMenu}
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
      
      <Drawer
        anchor="right"
        open={isMenuOpen}
        onClose={toggleMenu}
        classes={{ paper: 'drawer-paper' }}
      >
        <Box className="drawer-content">
          <Box className="drawer-header">
            <IconButton 
              onClick={toggleMenu}
              className="close-button"
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <List className="drawer-list">
            {menuData.map((item) => (
              <ListItem 
                key={item.id} 
                component="a" 
                href={item.link}
                onClick={toggleMenu}
                className="drawer-item"
              >
                <ListItemText primary={item.title} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
